import { formatServicePrice } from '../../utils/formatServicePrice';
import { cartItemWalletKind, type CheckoutSummaryTotal } from './checkoutPayload';

type CheckoutItemForPrice = {
  cartItemId: string;
  price: number;
  creditPrice?: number;
  payment_method?: string;
};

type TranslateFn = (key: string, opts?: { count?: number }) => string;

/** Libellé prix d’une ligne panier / checkout (hors montants Stripe agrégés). */
export function checkoutItemPriceLabel(
  item: CheckoutItemForPrice,
  usedByItem: Record<string, 'credits' | 'forfait' | 'none'>,
  t: TranslateFn,
  freeLabel: string
): string {
  const kind = cartItemWalletKind(item, usedByItem);
  if (kind === 'forfait') return t('confirm.includedInForfait');
  if (kind === 'credits') return t('confirm.creditsUnit', { count: item.creditPrice || 0 });
  return formatServicePrice(item.price, freeLabel) ?? '';
}

export function checkoutLineEuroPrice(price: number, freeLabel: string): string {
  return formatServicePrice(price, freeLabel) ?? '';
}

export function checkoutSummaryTotalLabel(
  calcs: CheckoutSummaryTotal,
  t: TranslateFn,
  freeLabel: string
): string {
  if (calcs.kind === 'forfait') return t('confirm.includedInForfait');
  if (calcs.kind === 'credits') return t('confirm.creditsUnit', { count: calcs.credits });
  if (calcs.amount === 0) return freeLabel;
  return `${calcs.amount}€`;
}
